// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3R2Wf","list":"styles_list__2RPw7"};